'use es6';

import UIList from 'UIComponents/list/UIList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RestrictedFieldsProblemMessage = ({
  message,
  restrictedFieldLevelProperties
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: message,
      options: {
        count: restrictedFieldLevelProperties.length
      }
    }), /*#__PURE__*/_jsx(UIList, {
      styled: true,
      className: 'p-top-2 m-bottom-2',
      children: restrictedFieldLevelProperties.map((restrictedField, index) => {
        const property = restrictedField.get('property');
        const propertyName = property.get('label');
        return /*#__PURE__*/_jsx("span", {
          children: propertyName
        }, index);
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'reporting-action-components.actions.askAnAccountAdminForAccess'
    })]
  });
};
export default RestrictedFieldsProblemMessage;